export const WarningTriangleFilledDotIcon = ({ color = "#FF6B6B", className = "" }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M8.90069 2.51375L14.3669 12.0056C14.7501 12.6744 14.2551 13.5 13.4663 13.5H2.53381C1.74506 13.5 1.25006 12.6744 1.63319 12.0056L7.09944 2.51375C7.49319 1.82875 8.50694 1.82875 8.90069 2.51375Z"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 9V6.5"
      stroke={color}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8 12C8.41421 12 8.75 11.6642 8.75 11.25C8.75 10.8358 8.41421 10.5 8 10.5C7.58579 10.5 7.25 10.8358 7.25 11.25C7.25 11.6642 7.58579 12 8 12Z"
      fill={color}
    />
  </svg>
);
